import { monthGrid, type StatusTone } from '@rydres/shared';

const DOT: Record<StatusTone, string> = { ok: 'bg-ok', warn: 'bg-warn', info: 'bg-info', danger: 'bg-danger', muted: 'bg-muted' };
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const longDate = (ymd: string) => new Date(`${ymd}T12:00:00Z`).toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric' });

/** A month on a calendar, Sunday first, with a dot for each ride (up to three) and today picked out. */
export function MonthGrid({
  month,
  today,
  selected,
  marks,
  onDay,
}: {
  /** Any date in the month. */
  month: string;
  today: string;
  selected?: string;
  /** Each date's rides, by the colour of their status. */
  marks: Record<string, StatusTone[]>;
  onDay: (ymd: string) => void;
}) {
  return (
    <div className="rounded-2xl border border-line bg-card p-2">
      <div className="grid grid-cols-7 text-center text-[11px] font-bold text-muted" aria-hidden="true">
        {WEEKDAYS.map((d) => <div key={d} className="py-1">{d}</div>)}
      </div>
      {monthGrid(month).map((week) => (
        <div key={week[0]} className="grid grid-cols-7">
          {week.map((ymd) => {
            const tones = marks[ymd] ?? [];
            return (
              <button
                key={ymd}
                type="button"
                aria-label={`${longDate(ymd)}${tones.length ? `, ${tones.length} ${tones.length === 1 ? 'ride' : 'rides'}` : ''}`}
                aria-pressed={selected === ymd}
                onClick={() => onDay(ymd)}
                className={`flex min-h-12 flex-col items-center gap-1 rounded-xl py-1 text-sm font-bold ${selected === ymd ? 'bg-accent-soft' : ''} ${ymd.slice(0, 7) === month.slice(0, 7) ? 'text-ink' : 'text-muted opacity-50'}`}
              >
                <span className={`flex h-6 w-6 items-center justify-center rounded-full ${ymd === today ? 'bg-brand text-on-brand' : ''}`}>{Number(ymd.slice(8))}</span>
                <span className="flex h-1.5 gap-0.5" aria-hidden="true">
                  {tones.slice(0, 3).map((t, i) => <span key={i} className={`h-1.5 w-1.5 rounded-full ${DOT[t]}`} />)}
                </span>
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
